module.exports = __webpack_public_path__ + "static/media/40-15.a7908090.mp3";